import seatmapSectionCodes from './seatmap-section-codes';

const CMS_URLS = {
  ABOUT: {
    en: 'about-us',
    es: 'acerca-de-aeromexico',
    it: 'informazioni-su-aeromexico',
    jp: 'about-us',
  },
  BAGGAGE: {
    en: 'travel-information/baggage',
    es: 'informacion-de-vuelos/equipaje',
    it: 'informazioni-sui-voli/bagagli',
    jp: 'travel-information/baggage',
  },
  BAGGAGE_CODESHARE: {
    en: 'travel-information/baggage/code-share',
    es: 'informacion-de-vuelos/equipaje/codigo-compartido',
    fr: 'informations-de-vols/bagages/codes-partages',
    pt: 'informacao-de-voos/bagagem/codeshare',
    it: 'informazioni-sui-voli/bagagli/codeshare',
    jp: 'travel-information/baggage/code-share',
  },
  CLUB_PREMIER: {
    en: 'flying-with-us/club-premier-rewards-program',
    es: 'vuela-con-nosotros/club-premier',
    pt: 'flying-with-us/club-premier-rewards-program',
    fr: 'volez-avec-nous/club-premier',
    it: 'vola-con-noi/club-premier',
    jp: 'flying-with-us/club-premier-rewards-program',
  },
  CONTACT_US: {
    en: 'contact-us',
    es: 'contacto',
    it: 'contatto',
    jp: 'contact-us',
  },
  CORPORATE: {
    en: 'about-us/aeromexico-corporate',
    es: 'acerca-de-aeromexico/corporativo-aeromexico',
    it: 'informazioni-su-aeromexico/struttura-societaria-aeromexico',
    jp: 'about-us/aeromexico-corporate',
  },
  CUBA_TRAVEL_TIPS: {
    en: 'blog-de-viajes-inspirate/consejos-y-requisitos-para-viajar-a-cuba',
    es: 'blog-de-viajes-inspirate/consejos-y-requisitos-para-viajar-a-cuba',
    it: 'blog-viaggio-caminos/consigli-e-requisiti-per-viaggiare-a-cuba',
    jp: 'blog-de-viajes-inspirate/consejos-y-requisitos-para-viajar-a-cuba',
  },
  DUTY_FREE_SHOP: {
    en: 'aeromexico-shop',
    es: 'tienda-aeromexico',
    fr: 'aeromexico-shop',
    pt: 'aeromexico-shop',
  },
  ECONOMY_PLUS: {
    en: 'flying-with-us/on-board-experience/economy-plus',
    es: 'vuela-con-nosotros/experiencia-a-bordo/extras-am-plus',
    it: 'vola-con-noi/esperienza-a-bordo/am-plus',
    jp: 'flying-with-us/on-board-experience/economy-plus',
  },
  FLEET: {
    en: 'flying-with-us/aeromexico-fleet',
    es: 'vuela-con-nosotros/flota-aeromexico',
    it: 'vola-con-noi/flotta-aeromexico',
    jp: 'flying-with-us/aeromexico-fleet',
  },
  FLY_WITH_US: {
    en: 'flying-with-us',
    es: 'vuela-con-nosotros',
    it: 'vola-con-noi',
    jp: 'flying-with-us',
  },
  INVESTORS: {
    en: 'investors',
    es: 'inversionistas',
    it: 'investitori',
    jp: 'investors',
  },
  LATEST_NEWS: {
    en: 'latest-news',
    es: 'noticias',
    it: 'notizia',
    jp: 'latest-news',
  },
  LEGAL: {
    en: 'legal-information',
    es: 'informacion-legal',
    fr: 'information-legale',
    pt: 'informacao-legal',
    it: 'informazione-legale',
    jp: 'legal-information',
  },
  MAINTENANCE: {
    en: 'flying-with-us/delta-air-lines-alliance',
    es: 'vuela-con-nosotros/alianza-delta-air-lines',
    it: 'vola-con-noi/alleanza-delta-air-lines',
    jp: 'flying-with-us/delta-air-lines-alliance',
  },
  PASSENGER_INFO: {
    en: 'travel-information/passengers',
    es: 'informacion-de-vuelos/pasajeros',
    it: 'informazioni-sui-voli/passeggeri',
    jp: 'travel-information/passengers',
  },
  PREMIER_UPGRADE: {
    en: 'flying-with-us/clase-premier-upgrade',
    es: 'vuela-con-nosotros/subasta-clase-premier',
  },
  PRESS: {
    en: 'about-us/press-room',
    es: 'acerca-de-aeromexico/sala-de-prensa',
    it: 'informazioni-su-aeromexico/sala-stampa',
    jp: 'about-us/press-room',
  },
  PROMOTIONS: {
    en: 'promotions',
    es: 'promociones',
    fr: 'promotions',
    it: 'promozioni',
    jp: 'promotions',
  },
  FLIGHT_STATUS: {
    en: 'flight-status',
    es: 'estatus-de-vuelo',
    fr: 'infos-vols',
    pt: 'voo-status',
    it: 'stato-del-volo',
    jp: 'flight-status',
  },
  DESTINATIONS_LANDING: {
    en: 'destinations',
    es: 'destinos',
    fr: 'destinations',
    it: 'destinazioni',
    jp: 'destinations',
  },
  SKY_TEAM: {
    en: 'flying-with-us/skyteam-alliance',
    es: 'vuela-con-nosotros/alianza-skyteam',
    it: 'vola-con-noi/alleanza',
    jp: 'flying-with-us/skyteam-alliance',
  },
  CARRERS: {
    es: 'https://aeromexicoformacion.com/',
    it: 'https://aeromexicoformacion.com/',
    jp: 'https://aeromexicoformacion.com/',
  },
  TICKET_OFFICES: {
    en: 'contact-us',
    es: {
      default: 'contacto',
      mx: 'oficinas-de-boletos',
      it: 'biglietteria',
    },
    it: 'contatto',
    jp: 'contact-us',
  },
  TRAVEL_INFORMATION: {
    en: 'travel-information',
    es: 'informacion-de-vuelos',
    it: 'informazioni-sui-voli',
    jp: 'travel-information',
  },
  TRAVEL_INFORMATION_PAYMENT_METHODS: {
    en: 'travel-information/payment-methods',
    es: 'informacion-de-vuelos/formas-de-pago',
    fr: 'informations-de-vols/moyens-de-paiement',
    pt: 'informacao-de-voos/formas-de-pagamento',
    it: 'informazioni-sui-voli/metodi-di-pagamento',
    jp: 'travel-information/payment-methods',
  },
  TRAVEL_INSURANCE_CHUBB: {
    en: 'flying-with-us/trip-extras/travel-insurance',
    es: 'vuela-con-nosotros/extras-para-tu-viaje/seguro-de-viaje',
  },
  TRIPS_EXTRAS: {
    en: 'flying-with-us/trip-extras',
    es: 'vuela-con-nosotros/extras-para-tu-viaje',
    fr: 'volez-avec-nous/extras-pour-votre-voyage',
    it: 'vola-con-noi/extra-per-il-viaggio',
    jp: 'flying-with-us/trip-extras',
  },
  UPGRADE: {
    en: 'flying-with-us/clase-premier-upgrade',
    es: 'vuela-con-nosotros/subasta-clase-premier',
    fr: 'vuela-con-nosotros/subasta-clase-premier',
    pt: 'flying-with-us/clase-premier-upgrade',
    it: 'vola-con-noi/asta-classe-premier',
    jp: 'flying-with-us/clase-premier-upgrade',
  },
  VACATIONS: {
    en: '',
    es: 'promociones/paquetes-gran-plan',
  },
  BOOK: {
    en: 'book',
    es: 'reserva',
    fr: 'reservez',
    pt: 'reserva',
    it: 'prenotazione',
    jp: 'book',
  },
  MANAGE_YOUR_BOOKING: {
    en: 'manage-your-booking',
    es: 'administra-tu-viaje',
    fr: 'gerez-votre-reservation',
    pt: 'gerencie-sua-reserva',
    it: 'gestisci-viaggio',
    jp: 'manage-your-booking',
  },
  CHECK_IN: {
    en: 'check-in',
    es: 'check-in',
    fr: 'enregistrement',
    pt: 'check-in',
    it: 'check-in',
    jp: 'check-in',
  },
  CHECK_IN_BANNER: {
    en: 'check-in/flights',
    es: 'check-in/vuelos',
    fr: 'enregistrement/vols',
    pt: 'check-in/voos',
    it: 'check-in/volo',
    jp: 'check-in/flights',
  },
  HEADER_FOURTH_ITEM: {
    fr: 'mesures-de-sante-et-dhygiene',
  },
  HEADER_MYTRIPS_FOURTH_ITEM: {
    fr: 'politique-de-flexibilite-juillet',
  },
  BOOK_FLIGHT_OPTIONS: {
    en: 'book/options',
    es: 'reserva/opciones',
    fr: 'reservez/options',
    pt: 'reserva/opcoes',
    it: 'prenotazione/opzioni',
    jp: 'book/options',
  },
};

const SEATMAP_SECTION_URLS = {
  SEATS: {
    en: 'travel-information/seats-and-cabins',
    es: 'informacion-de-vuelos/asientos-y-cabinas',
    fr: 'travel-information/seats-and-cabins',
    pt: 'travel-information/seats-and-cabins',
    it: 'Informazioni-sui-voli/posti-e-classi',
    jp: 'travel-information/seats-and-cabins',
  },
  [seatmapSectionCodes.AM_PLUS]: {
    en: 'flying-with-us/on-board-experience/economy-plus',
    es: 'vuela-con-nosotros/experiencia-a-bordo/extras-am-plus',
    fr: 'flying-with-us/on-board-experience/economy-plus',
    pt: 'flying-with-us/on-board-experience/economy-plus',
    it: 'vola-con-noi/esperienza-a-bordo/am-plus',
    jp: 'flying-with-us/on-board-experience/economy-plus',
  },
  [seatmapSectionCodes.FIRST_CLASS]: {
    en: 'flying-with-us/on-board-experience/clase-premier-business-class',
    es: 'vuela-con-nosotros/experiencia-a-bordo/clase-premier',
    fr: 'flying-with-us/on-board-experience/clase-premier-business-class',
    pt: 'flying-with-us/on-board-experience/clase-premier-business-class',
  },
  [seatmapSectionCodes.PREFERRED]: {
    en: 'travel-information/seats-and-cabins',
    es: 'informacion-de-vuelos/asientos-y-cabinas',
    fr: 'travel-information/seats-and-cabins',
    pt: 'travel-information/seats-and-cabins',
    it: 'Informazioni-sui-voli/posti-e-classi',
    jp: 'travel-information/seats-and-cabins',
  },
  [seatmapSectionCodes.EXIT_ROW]: {
    en: 'travel-information/seats-and-cabins',
    es: 'informacion-de-vuelos/asientos-y-cabinas',
    fr: 'travel-information/seats-and-cabins',
    pt: 'travel-information/seats-and-cabins',
    it: 'Informazioni-sui-voli/posti-e-classi',
    jp: 'travel-information/seats-and-cabins',
  },
  [seatmapSectionCodes.COACH]: {
    en: 'travel-information/seats-and-cabins',
    es: 'informacion-de-vuelos/asientos-y-cabinas',
    fr: 'travel-information/seats-and-cabins',
    pt: 'travel-information/seats-and-cabins',
    it: 'Informazioni-sui-voli/posti-e-classi',
    jp: 'travel-information/seats-and-cabins',
  },
};

function getCMSUrl(storefront, language, id) {
  if (!CMS_URLS[id]) {
    throw new Error(`CMS URL not configured: "${id}"`);
  }

  // we may have url's specific to a given storefront. Detect if there' a storefront specific url,
  // then fallback to the default storefront setting or language

  const splitStorefront = storefront.split('-');
  let newStorefront = storefront;

  if (splitStorefront && splitStorefront.length && splitStorefront.length === 2) {
    newStorefront = splitStorefront?.[1] || storefront;
  }

  const urlID = CMS_URLS[id][language] ?
    CMS_URLS[id][language][newStorefront] ?
      CMS_URLS[id][language][newStorefront] :
      CMS_URLS[id][language].default ? CMS_URLS[id][language].default : CMS_URLS[id][language] : null;

  return `${location.protocol}//${location.host}/${language}-${newStorefront}/${urlID}`;
}

function getCMSUrlCheckIn(storefront, language, id, pnrCode, lastName) {
  if (!CMS_URLS[id]) {
    throw new Error(`CMS URL not configured: "${id}"`);
  }
  // we may have url's specific to a given storefront. Detect if there' a storefront specific url,
  // then fallback to the default storefront setting or language
  const urlID = CMS_URLS[id][language] ?
    CMS_URLS[id][language][storefront] ?
      CMS_URLS[id][language][storefront] :
      CMS_URLS[id][language].default ? CMS_URLS[id][language].default : CMS_URLS[id][language] : null;
  return `${location.protocol}//${location.host}/${storefront}/${urlID}?last-name=${lastName}&pnr=${pnrCode}`;
}

function getCMSUrlToHome(storefront, language, id) {
  const urlID = id;
  return `${location.protocol}//${location.host}/${language}-${storefront}/${urlID}`;
}

function getCMSRoutes(storefront, language) {
  return `https://flights.aeromexico.com/${language}-${storefront}`;
}

function getCMSHome(storefront, language) {
  return `${location.protocol}//${location.host}/${language}-${storefront}/`;
}

function getCMSUrlToPromotions(storefront, id) {
  let urlID = id;
  if ((urlID).startsWith('/')) {
    urlID = (urlID).substring(1);
  }
  return `${location.protocol}//${location.host}/${storefront}/${urlID}`;
}

export {
  getCMSUrl,
  getCMSUrlCheckIn,
  getCMSHome,
  getCMSRoutes,
  getCMSUrlToHome,
  getCMSUrlToPromotions,
  CMS_URLS,
  SEATMAP_SECTION_URLS,
};
